import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["display"];
  static values = {
    expiresAt: Number, // epoch seconds
  };

  connect() {
    this.tick();
    this.timer = setInterval(this.tick.bind(this), 1000);
  }

  disconnect() {
    clearInterval(this.timer);
  }

  tick() {
    const now = Math.floor(Date.now() / 1000);
    const remainingSeconds = this.expiresAtValue - now;

    if (remainingSeconds <= 0) {
      this.displayTarget.textContent = "00:00";
      clearInterval(this.timer);
      return;
    }

    const minutes = Math.floor(remainingSeconds / 60);
    const seconds = remainingSeconds % 60;

    this.displayTarget.textContent = `${this.pad(minutes)}:${this.pad(seconds)}`;
  }

  pad(value) {
    return String(value).padStart(2, "0");
  }
}
